var Queensland = "Queensland";
var Tasmania = "Tasmânia";
var Victoria = "Victoria";
var AUStates = {
	"Australian Capital Territory": "Território da Capital Australiana",
	"New South Wales": "Nova Gales do Sul",
	"Northern Territory": "Território do Norte",
	Queensland: Queensland,
	"South Australia": "Austrália Meridional",
	Tasmania: Tasmania,
	Victoria: Victoria,
	"Western Australia": "Austrália Ocidental"
};

export { Queensland, Tasmania, Victoria, AUStates as default };
